import { Link } from 'react-router-dom'

import routes, { categoriesGroup } from '../../routers'
import { CardScanArt } from '../ScanRecipeCard'
import { WebRecipeArt } from '../RecipeFromLink'

import '../ScanRecipeCard/style.css'
import './style.css'

// A recipe card with a pencil, for "Type it in"
const TypeItArt = () => (
  <svg viewBox="0 0 64 64" width="56" height="56">
    <rect
      x="8"
      y="14"
      width="40"
      height="34"
      rx="3"
      fill="#fffdf2"
      stroke="#37190c"
      strokeWidth="2.5"
    />
    <path d="M8 22h40" stroke="#d9483b" strokeWidth="1.8" />
    <path
      d="M14 30h22M14 37h16"
      fill="none"
      stroke="#37190c"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <g transform="rotate(40 46 40)">
      <rect
        x="42"
        y="18"
        width="8"
        height="30"
        rx="1.5"
        fill="#fec925"
        stroke="#37190c"
        strokeWidth="2.2"
      />
      <path
        d="M42 48l4 7 4-7z"
        fill="#fffdf2"
        stroke="#37190c"
        strokeWidth="2.2"
        strokeLinejoin="round"
      />
    </g>
  </svg>
)

const OPTIONS = [
  {
    to: `${routes.addRecipe}?start=scan`,
    Art: CardScanArt,
    title: 'Scan a recipe card',
    text: "Snap a photo of a card or a cookbook page. We'll type it up for you.",
  },
  {
    to: `${routes.addRecipe}?start=link`,
    Art: WebRecipeArt,
    title: 'Paste a link',
    text: "Found it on a website? Paste the link and we'll fill in the recipe.",
  },
  {
    to: routes.addRecipe,
    Art: TypeItArt,
    title: 'Type it in',
    text: 'Write it out yourself, one step at a time.',
  },
]

/**
 * What someone sees before they have any recipes: the three ways to add the first one.
 * `welcome` is the first visit, straight from the confirmation email.
 * `family` is a family group they were invited to, so they can see its recipes first.
 */
const FirstRecipeStart = ({ welcome = false, firstName = '', family = null }) => (
  <section className="firstRecipeStart" aria-labelledby="firstRecipeStartTitle">
    <h2 id="firstRecipeStartTitle" className="firstRecipeStartTitle">
      {welcome ? `Welcome to Morsel${firstName ? `, ${firstName}` : ''}!` : 'Add your first recipe'}
    </h2>
    <p className="firstRecipeStartText">
      {welcome
        ? "Let's save your first family recipe. Pick whichever is easiest, it only takes a couple of minutes."
        : 'Pick whichever is easiest. It only takes a couple of minutes.'}
    </p>
    {family ? (
      <p className="firstRecipeStartFamily">
        You're in <strong>{family.name}</strong>.{' '}
        <Link to={categoriesGroup(family.slug, family.id)}>See the family's recipes</Link>, then add
        one of yours.
      </p>
    ) : null}
    <div className="firstRecipeStartOptions">
      {OPTIONS.map(({ to, Art, title, text }) => (
        <Link key={title} to={to} className="quickTile">
          <span className="quickTileIcon" aria-hidden="true">
            <Art />
          </span>
          <span className="quickTileTitle">{title}</span>
          <span className="quickTileText">{text}</span>
        </Link>
      ))}
    </div>
  </section>
)

export default FirstRecipeStart
